import loadable from '@loadable/component';

import { AccountPermission } from 'modules/permissions/constants';
import { GuardAccountPermission } from 'modules/account/components/GuardAccountPermission';
import { Page } from 'modules/layout/components/Page';

import { ChainsListPageSkeleton } from './components/ChainsListPageSkeleton';
import { useChainsListPageStyles } from './useChainsListPageStyles';

const ChainsListPage = loadable(
  async () => {
    const module = await import('./ChainsListPage');

    return module.ChainsListPage;
  },
  {
    fallback: <ChainsListPageSkeleton />,
  },
);

export const ChainsListPageContainer = () => {
  const { classes } = useChainsListPageStyles();

  return (
    <Page classes={classes}>
      <GuardAccountPermission
        fallback={<ChainsListPageSkeleton />}
        permission={AccountPermission.ChainItem}
        shouldHideAlert
        shouldRedirect
      >
        <ChainsListPage />
      </GuardAccountPermission>
    </Page>
  );
};
